/* Rquiere de mixin.js */

var typeColportor = {
	data() {
		return {
			listTypesColportor: [],
			methodsTypeColportor: {
				get: 'typesColportor',
				show: 'typeColportor/',
			},
			paginationTypesColportor: [],
			searchTypesColportor: '',
		}
	},
	computed: {
	},
	filters: {
	},
	methods: {
		getAllTypesColportor(page = 1) {
			let parameters = '?search=' + this.searchTypesColportor + '&page=' + page
			this.axiosActionIS(this.apiBackend + this.methodsTypeColportor.get + parameters, 'GET', 'getAllTypesColportorResult')
		},
		getAllTypesColportorResult(response) {
			if (response.data.success) {
				this.listTypesColportor = response.data.data
				this.paginationTypesColportor = response.data.paginate
			}
			this.getAllTypesColportorResultLocal(response)
		},
		getAllTypesColportorResultLocal(response) {
			console.log('getAllTypesColportorResultLocal no desarrollado', response)
		},
		getTypeColportor(id) {
			this.axiosActionIS(this.apiBackend + this.methodsTypeColportor.show + id, 'GET', 'getTypeColportorResult')
		},
		getTypeColportorResult(response) {
			this.getTypeColportorResultLocal(response)
		},
		getTypeColportorResultLocal(response) {
			console.log('getTypeColportorResultLocal no está desarrollado', response)
		},
	},
};

export default typeColportor;